import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const NoteIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.99992 5.16667H9.99992M5.99992 7.83333H9.99992M5.99992 10.5H8.66659M3.33325 3.83333C3.33325 3.47971 3.47373 3.14057 3.72378 2.89052C3.97382 2.64048 4.31296 2.5 4.66659 2.5H11.3333C11.6869 2.5 12.026 2.64048 12.2761 2.89052C12.5261 3.14057 12.6666 3.47971 12.6666 3.83333V13.1667C12.6666 13.5203 12.5261 13.8594 12.2761 14.1095C12.026 14.3595 11.6869 14.5 11.3333 14.5H4.66659C4.31296 14.5 3.97382 14.3595 3.72378 14.1095C3.47373 13.8594 3.33325 13.5203 3.33325 13.1667V3.83333Z"
          stroke="#5D708C"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
